module.exports = __webpack_public_path__ + "media/components/country-flag/static/hu-e027b295888398dbd3a764e977fed072.svg";